  {{#if (hasAny entity 'dateOfBirth' 'dateOfDeath')}}
  <tr class="gnd-infobox-biographical">    
    <th>Lebensdaten:</th>
    <td>
      <dl>
        {{#if (prop entity 'dateOfBirth') }}
        <dd class="gnd-infobox-birth">
          * {{formatDate entity.dateOfBirth }}
          {{#if entity.placeOfBirthAsLiteral}}
          ({{entity.placeOfBirthAsLiteral}})
          {{else}}
            {{#if (prop entity 'placeOfBirth') }}
            ({{prop entity 'placeOfBirth'}})
            {{/if}}
          {{/if}}
        </dd>
        {{/if}}
        {{#if (prop entity 'dateOfDeath') }}
        <dd class="gnd-infobox-death">
          † {{formatDate entity.dateOfDeath }}
          {{#if (prop entity 'placeOfDeath')}}
          ({{prop entity 'placeOfDeath'}})
          {{/if}}
        </dd>
        {{/if}}
      </dl>
    </td>
  </tr>
  {{/if}}
  {{#if entity.biographicalOrHistoricalInformation }}
  <tr class="gnd-infobox-biographical-or-historical-information">
    <th>
      Anmerkungen:
    </th>
    <td>
      <dl>
        {{#each (arrayify (prop entity 'biographicalOrHistoricalInformation')) as |info|}}
        <dd>
        {{ info }}
        </dd>
        {{/each}}
      </dl>
    </td>  
  </tr>
  {{/if}}
  {{#if entity.periodOfActivity}}
  <tr class="gnd-infobox-period-of-activity">
    <th>Wirkungsdaten:</th>
    <td>
      <dl>
        <dd>{{prop entity 'periodOfActivity'}}</dd>
      </dl>
    </td>
  </tr>
  {{/if}}
  {{#if entity.geographicAreaCode}}
  <tr class="gnd-infobox-geographic-area-code">
    <th>Land:</th>
    <td>
      <dl>
        {{#each (arrayify entity.geographicAreaCode) as |ac|}}
        <dd>
          {{prefLabelInGraph ac.[@id] 'gnd-ac'}}
        </dd>
        {{/each}}
      </dl>
    </td>
  </tr>
  {{/if}}
  {{#if entity.gender}}
  <tr class="gnd-infobox-gender">
    <th>Geschlecht:</th>
    <td>
      <dl>        
        <dd>
          {{gndGender entity.gender.[@id]}}
        </dd>
      </dl>
    </td>
  </tr>
  {{/if}}
  {{#if entity.professionOrOccupation}}
  <tr class="gnd-infobox-profession-or-occupation">
    <th>Tätigkeitsfelder:</th>
    <td>
      <dl>
        {{#each (arrayify entity.professionOrOccupation) as |subentity|}}
        <dd>
          <a href="{{hrefGnd subentity.[@id]}}">{{ subentity.preferredName }}</a>
        </dd>
        {{/each}}
      </dl>
    </td>
  </tr>
  {{/if}}
  {{#if entity.academicDegree}}
  <tr class="gnd-infobox-academic-degree">
    <th>Akad. Titel:</th>
    <td>
      <dl>
        {{#each (arrayify entity.academicDegree) as |degree|}}
        <dd>
          {{degree}}
        </dd>
        {{/each}}
      </dl>
    </td>
  </tr>
  {{/if}}
  {{#if entity.titleOfNobilityAsLiteral}}
  <tr class="gnd-infobox-title-of-nobility">
    <th>Weitere Titel:</th>
    <td>
      <dl>
        {{#each (arrayify entity.titleOfNobilityAsLiteral) as |subentity|}}
        <dd>
          {{ subentity }}
        </dd>
        {{/each}}
      </dl>
    </td>
  </tr>
  {{/if}}
  {{#if entity.familialRelationship}}
  <tr class="gnd-infobox-familial-relationship">
    <th>Verwandschaft:</th>
    <td>
      <dl>
        {{#each (arrayify entity.familialRelationship) as |subentity|}}
        <dd>
          <a href="{{hrefGnd subentity.[@id]}}">{{ subentity.preferredName }}</a>
        </dd>
        {{/each}}
      </dl>
    </td>
  </tr>
  {{/if}}
  {{#if entity.affiliation}}
  <tr class="gnd-infobox-affiliation">
    <th>Körperschaft:</th>
    <td>
      <dl>
        {{#each (arrayify entity.affiliation) as |subentity|}}
        <dd>
          <a href="{{hrefGnd subentity.[@id]}}">{{ subentity.preferredName }}</a>
        </dd>
        {{/each}}
      </dl>
    </td>
  </tr>
  {{/if}}
  {{#if entity.placeOfActivity}}
  <tr class="gnd-infobox-place-of-activity">
    <th>Wirkungsort:</th>
    <td>
      <dl>
        {{#each (arrayify entity.placeOfActivity) as |subentity|}}
        <dd>
          <a href="{{hrefGnd subentity.[@id]}}">{{ subentity.preferredName }}</a>
        </dd>
        {{/each}}
      </dl>
    </td>
  </tr>
  {{/if}}
  {{#if (variantName entity) }}
  <tr class="gnd-infobox-variant-names">
    <th>Varianten:</th>
    <td>
      <dl>
        {{#each (arrayify (variantName entity)) as |name|}}
        <dd class="gnd-infobox-variant-name">{{ name }}</dd>
        {{/each}}
      </dl>
    </td>
  </tr>
  {{/if}}
